module.exports = __webpack_public_path__ + "assets/ed3df827c1e68d174a182ca7a4695a91.svg";